@let results = extractionResults();
@if (results) {
  <div class="flex h-full w-full">
    <div
      class="border-ci-lightblack flex min-h-0 w-60 shrink-0 flex-col gap-4 overflow-auto border-r p-4">
      @for (entry of results | keyvalue; track $index) {
        @let documentId = entry.key;
        <div
          class="border-theme-gray-600 flex w-full flex-col gap-1.5 rounded-xl border p-4 text-center transition-colors select-text">
          <span>Dokument {{ $index }}</span>
          @for (resultByClass of entry.value | keyvalue; track $index) {
            @let documentId = entry.key;
            @let documentClass = resultByClass.key;
            <button
              class="border-theme-gray-400 rounded-md border p-1.5 text-xs"
              (click)="selectParameters(documentId, documentClass)"
              [ngClass]="
                documentId === selectedExtractionParameters()?.documentId &&
                documentClass === selectedExtractionParameters()?.documentClass
                  ? 'bg-theme-blue/30'
                  : 'bg-theme-gray-300 hover:bg-theme-blue/10'
              ">
              {{ documentClass }}
            </button>
          }
          <span class="text-theme-gray-600 text-xs">({{ documentId.substring(0, 8) }})</span>
        </div>
      }
    </div>
    @let selectedResult = this.selectedExtractionResult();
    @if (selectedResult) {
      <div class="flex h-full grow flex-col">
        <div class="flex gap-1.5 p-1.5">
          <button (click)="expandAll()" class="border-theme-gray-400 rounded-md border p-1.5">
            Alles ausklappen
          </button>
          <button (click)="collapseAll()" class="border-theme-gray-400 rounded-md border p-1.5">
            Alles einklappen
          </button>
        </div>
        <hr />
        <ct-extraction-nxt-json-view
          #jsonView
          class="min-h-0 grow overflow-auto p-4"
          [data]="selectedResult" />
      </div>
    } @else {
      Dokument links wählen...
    }
  </div>
} @else {
  Daten werden geladen..
}
